export default "/corgi/pageapps/prepurchase/_next/static/media/energy-tag-range.7e41d2f3.svg";